// extracted by mini-css-extract-plugin
module.exports =  {"root":"SoexGj9raeqaIE2rRMGr"};